import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: '2px',
      padding: '5px 10px',
      border: `solid ${palette.common.primaryRed} 2px`,
      borderRadius: palette.borderRadius.default,
      '& ul': {
        padding: '0 15px'
      }
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
